import * as React from 'react';
import type { SVGProps } from 'react';
const SvgIncident = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 21 21"
    {...props}
  >
    <path d="M9.627 17.604c.043.033.016.114-.038.107-2.029-.262-4.923-1.594-4.381-5.495.298-2.145.926-3.285 1.492-4.313.688-1.249 1.285-2.332 1.09-4.849-.057-.743.858-1.192 1.264-.567.767 1.182 1.52 2.85 1.846 5.248.229 1.678 1.358 2.06 1.621.387.082-.52.144-1.06.187-1.597.05-.62.854-.848 1.154-.302 2.581 4.687 3.392 10.501-2.39 11.425-.052.009-.086-.066-.047-.1a2.7 2.7 0 0 0 .432-3.349l-1.08-1.775a.33.33 0 0 0-.572.011l-.826 1.481-.26.474a2.68 2.68 0 0 0 .343 3.07l.103.09q.03.029.062.053Z" />
  </svg>
);
export default SvgIncident;
